import { IndexedDbFactory } from '../factories/indexeddb-provider.factory';
import type { IMetadataKeyRepository } from '@app/domain/ports';
import { IndexedDbRepositoryBase } from './base-indexdb.repository';

export class MetadataKeyRepository extends IndexedDbRepositoryBase implements IMetadataKeyRepository {
  constructor(indexedDbFactory: IndexedDbFactory) {
    super(indexedDbFactory, 'keys');
  }

  async set<T = unknown>(key: string, value: T): Promise<void> {
    await this.executeStoreOperation('set', { key }, async (db) => {
      // The 'keys' store uses out-of-line keys, so the key is passed as the second argument.
      await db.keys.put(value as unknown, key);
    });
  }

  async get<T = unknown>(key: string): Promise<T | undefined> {
    return this.executeStoreOperation('get', { key }, async (db) => (await db.keys.get(key)) as T | undefined);
  }

  async delete(key: string): Promise<void> {
    await this.executeStoreOperation('delete', { key }, async (db) => {
      await db.keys.delete(key);
    });
  }

  async clear(): Promise<void> {
    await this.executeStoreOperation('clear', {}, async (db) => {
      await db.keys.clear();
    });
  }
}
